import { FilterFieldValue } from '../covance-filter';
import { HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { uniqBy } from 'lodash';

export function prepareFilterUrlParams(filterParameters: FilterFieldValue[], isKitInventory = false): HttpParams {
    if (!filterParameters) {
        return null;
    }
    
    let httpParams = new HttpParams();
    filterParameters
        .filter(p => p.value)
        .forEach((filterParam) => {
            const filterValue = filterParam.value;
            const paramName = filterParam.def.queryParam;

            if (isKitInventory && paramName === 'site') {
                let sites: string[] = [];
                filterValue.forEach((site: { key: string, value: string, siteProject: any }) => {
                    sites.push(site.key.split('-')[0]);
                    httpParams = httpParams.append('siteProject', JSON.stringify(site.siteProject));
                });
                sites = uniqBy(sites, (site => site));
                sites.forEach(s => httpParams = httpParams.append(paramName, s));
                return;
            }

            if (paramName === 'date') {
                httpParams = httpParams.append('dateFrom', (filterValue.dateBegin) ? moment(filterValue.dateBegin).format('YYYY-MM-DDTHH:mm:ss') : '');
                httpParams = httpParams.append('dateTo', (filterValue.dateEnd) ? moment(filterValue.dateEnd).format('YYYY-MM-DDTHH:mm:ss') : '');
                return;
            }

            if (paramName === 'expirationDate') {
                httpParams = httpParams.append('expirationDateFrom', (filterValue.dateBegin) ? moment(filterValue.dateBegin).format('YYYY-MM-DDTHH:mm:ss') : '');
                httpParams = httpParams.append('expirationDateTo', (filterValue.dateEnd) ? moment(filterValue.dateEnd).format('YYYY-MM-DDTHH:mm:ss') : '');
                return;
            }

            if (paramName === 'sentDate') {
                httpParams = httpParams.append('sentDateFrom', (filterValue.dateBegin) ? moment(filterValue.dateBegin).format('YYYY-MM-DDTHH:mm:ss') : '');
                httpParams = httpParams.append('sentDateTo', (filterValue.dateEnd) ? moment(filterValue.dateEnd).format('YYYY-MM-DDTHH:mm:ss') : '');
                return;
            }

            if (Array.isArray(filterValue)) {
                filterValue
                    .forEach(v => httpParams = httpParams.append(paramName, v.key || v));
            } else {
                httpParams = httpParams.append(paramName, filterValue.key || filterValue);
            }
        });

    return httpParams;
}